import Image1 from '../../assets/seenitMain.png';
import Image2 from '../../assets/webMaven.jpg';
import Image3 from '../../assets/listConnectionMain.png';
import Image4 from '../../assets/kvcode-screenshot.png';

export const Data = [
    {
        id: 1,
        image: Image1,
        title: 'Seenit',
        github:'https://github.com/kv2461/seenit',
        live:'http://seenit.vercel.app/', 
        description: 'Seenit is a full stack Reddit clone that allows users to login using their Reddit accounts and allows them create Subseenits and posts, with comment and post functionality! Working on implementing search by subseenit and post - dependent on vote score.' 
    },
    {
        id: 2,
        image: Image2,
        title: 'Web Maven',
        github:'https://github.com/kv2461/web-maven',
        live:'https://chrome.google.com/webstore/detail/web-maven/hkpkpgejgeobkdpgmflkgcmahajkljkh?hl=en',
        description: "Web Maven is a chrome extension, more specifically, a social web browsing companion that allows users to share bookmarks with other users, who can be given editor or viewer rights, as well as a rating system for URL's that calculates the average of user-generated votes."
    },
    {
        id: 3,
        image: Image3,
        title: 'List Connection',
        github:'https://github.com/kv2461/list-connection',
        live:'https://list-connection.netlify.app/',
        description: "List Connection is a social media website for lists meant for recommendations, ranking, or regular list sharing. Create a yoga workout list, music playlist, and even recipes!"
    },
    {
        id: 4,
        image: Image4,
        title: 'My Website Services Page',
        github:'https://github.com/kv2461/landingpage',
        live:'https://kvcode.netlify.app/',
        description: 'Need help with your website? Ask me for help!'
    },
]